import axios from "axios";
import { GRAPH_BASE_URL } from "../Config/Config";

import { Client } from "@microsoft/microsoft-graph-client";
import "isomorphic-fetch";

export const GRAPH_ENDPOINTS = {
  SEARCH_PERSON: (searchString) =>
    `${GRAPH_BASE_URL}/me/people/?$filter=personType/class eq 'Person' and personType/subclass eq 'OrganizationUser'&$search="${searchString}"`,
  SEARCH_USERS: (searchString) =>
    `${GRAPH_BASE_URL}/users?$select=displayName,id,accountEnabled,userPrincipalName,givenName,displayName` +
    `&$filter=startswith(displayName,'${searchString}')` +
    ` or startswith(userPrincipalName,'${searchString}')` +
    ` or startswith(givenName,'${searchString}')` +
    ` or startswith(surname,'${searchString}')` +
    ` or startswith(mail,'${searchString}')`,
};

export function getAuthenticatedClient(accessToken) {
  return Client.init({
    authProvider: (done) => {
      done(null, accessToken);
    },
  });
}
// Récupérer l'accessToken de profil utilisateur
export const getAccessToken = (msalInstance,activeAccount) => {
    return new Promise((resolve) => {
          const accessTokenRequest = {
            account: activeAccount,
          };
          // Tenter de récupérer le token d'accès de manière silencieuse
          msalInstance
            .acquireTokenSilent(accessTokenRequest)
            .then((response) => {
              resolve(response.accessToken); // Résoudre avec le token d'accès
            })
            .catch((error) => {
              console.error(
                "Erreur lors de l'obtention du token d'accès :",
                error
              );
              resolve();
            });
        })
      
  };
  export async function getUserPhoto(graphClient, userId) {
    var photoUrl = "https://graph.microsoft.com/v1.0/users/" + userId + "/photo/$value";
    return new Promise(async (resolve, reject) => {
        setTimeout(() => {
            graphClient
                .api(photoUrl)
                .get().then((photo) => {
                    resolve(photo)
                }).catch(e => {
                    resolve(null)
                })
        }, 500);


    });
}
export const getUserData = (accessToken, userId) => {
  return new Promise((resolve) => {
    const url = `${GRAPH_BASE_URL}/users/${userId}`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
  
          resolve(response.data); 
       
      })
      .catch((error) => {
        resolve(error);
      });
  });
};



export const getAgentPhoto = (userId, accessToken) => {
  return new Promise((resolve) => {
    try {
      const url = `${GRAPH_BASE_URL}/users/${userId}/photo/$value`;

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "image/jpg",
          },
          responseType: "blob",
        })
        .then((response) => {
          if (response.status === 200) {
            // Si la requête réussie, créez un objet URL pour l'image
            const imageUrl = URL.createObjectURL(response.data);
            resolve(imageUrl);
          } else {
            // Si l'image n'est pas trouvée ou autre problème, retourne null
            resolve(null);
          }
        })
        .catch((error) => {
          resolve(null);
        });
    } catch (error) {
      // En cas d'erreur dans la logique de la fonction, retourner null
      resolve(null);
    }
  });
};

// Récupérer la présence de plusieurs agents
export const getAgentsPresence = (userIds, accessToken) => {
  return new Promise((resolve) => {
    const url = `${GRAPH_BASE_URL}/communications/getPresencesByUserId`;
    axios
      .post(
        url,
        {
          ids: userIds,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => resolve(response.data))
      .catch((error) => {
        console.error('Erreur lors de la récupération de la présence des utilisateurs:', error);
        resolve([]);
      });
  });
};

//search persona & user et écraser le persona dans ancien heedify à vérifier
export function searchContactFullinfos(msalInstance, activeAccount, searchString) {
  return getAccessToken(msalInstance, activeAccount)
    .then((accessToken) => getAuthenticatedClient(accessToken))
    .then((client) => {
      const url = GRAPH_ENDPOINTS.SEARCH_USERS(searchString);
      return client.api(url).get();
    })
    .then((response) => response.value || [])
    .catch((error) => {
      console.error("Erreur lors de la recherche du contact :", error);
      return [];
    });
}